import * as React from "react"

import { cn } from "../lib/utils"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-12 w-full rounded-full border-2 border-foreground bg-transparent px-4 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-foreground/50 focus-visible:placeholder:text-brand-primary/50 focus-visible:outline-none focus:bg-background focus-within:shadow-[0_0_10px_0_rgba(255,255,255,0.40),0_1px_2px_0_rgba(255,255,255,0.25),0_1px_3px_1px_rgba(255,255,255,0.25)] focus-within:shadow-foreground/20 disabled:cursor-not-allowed disabled:opacity-50 transition-colors duration-200",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
